export const STAKING_V2_ADDRESS = '0x0000000000000000000000000000000000000805' as const;
export const ALPHA_PRECOMPILE_ADDRESS = '0x0000000000000000000000000000000000000808' as const;
export const ADDRESS_MAPPING_ADDRESS = '0x000000000000000000000000000000000000080C' as const;
